export default function BasicInfoSection({
  values,
  errors,
  handleChange,
  labelStyle,
  inputStyle,
  salaryPrevDisplay,
  salaryReqDisplay,
  handlePrevSalaryChange,
  handleReqSalaryChange,
  handleStatusChange,
}) {
  return (
    <>
      <div className="grid-section">
        {/* First Name */}
        <div>
          <label style={labelStyle}>
            ຊື່
            {!values.firstName && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="firstName"
            value={values.firstName}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນຊື່"
          />
          {errors.firstName && (
            <p className="error-text">{errors.firstName}</p>
          )}
        </div>

        {/* Last Name */}
        <div>
          <label style={labelStyle}>
            ນາມສະກຸນ
            {!values.lastName && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="lastName"
            value={values.lastName}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນນາມສະກຸນ"
          />
          {errors.lastName && <p className="error-text">{errors.lastName}</p>}
        </div>
      </div>

      {/* Position */}
      <div style={{ marginTop: "1.3rem" }}>
        <label style={labelStyle}>
          ເລືອກຕຳແໜ່ງ
          {!values.position && (
            <span style={{ color: "red", marginLeft: 4 }}>*</span>
          )}
        </label>
        <select
          name="position"
          value={values.position}
          onChange={handleChange}
          style={{ ...inputStyle, cursor: "pointer" }}
        >
          <option value="">ເລືອກຕຳແໜ່ງ</option>
          <option value="CUSTOMER_SERVICE">ພ/ງ ບໍລິການລູກຄ້າ</option>
          <option value="HR">ບຸກຄາລະກອນ</option>
          <option value="ACCOUNTANT">ບັນຊີ</option>
          <option value="FINANCE">ການເງິນ</option>
          <option value="LAW">ກົດໝາຍ</option>
          <option value="STATE_DIRECTOR">ຫົວໜ້າບໍລິຫານສາຂາ</option>
          <option value="BRANCH_DIRECTOR">ຫົວໜ້າສາຂາ</option>
          <option value="IT">ໄອທີ</option>
          <option value="CALL_CENTER">ຕ້ອນຮັບ</option>
          <option value="ADMIN">ເເອັດມິນ</option>
          <option value="DRIVER_DIRECTOR">ຫົວໜ້າໂຊເເຟີ</option>
          <option value="DRIVER">ຄົນຂັບລົດ</option>
          <option value="AUDITION_DIRECTOR">ຫົວໜ້າສູນຄັດແຍກ</option>
          <option value="AUDITION_STAFF">ພ/ງ ສູນຄັດແຍກ</option>
          <option value="SHIPPER">ໄລເດີ້</option>
          <option value="OTHER">ອື້ນໆ...</option>
        </select>
        {errors.position && <p className="error-text">{errors.position}</p>}
      </div>

      <div className="grid-section" style={{ marginTop: "1.3rem" }}>
        {/* ວັນເດືອນປີເກີດ */}
        <div>
          <label style={labelStyle}>
            ວັນເດືອນປີເກີດ
            {!values.dateOfBirth && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="date"
            name="dateOfBirth"
            value={values.dateOfBirth}
            onChange={handleChange}
            style={inputStyle}
          />
          {errors.dateOfBirth && (
            <p className="error-text">{errors.dateOfBirth}</p>
          )}
        </div>

        {/* ສັນຊາດ */}
        <div>
          <label style={labelStyle}>
            ສັນຊາດ
            {!values.nationality && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="nationality"
            value={values.nationality}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນສັນຊາດ"
          />
          {errors.nationality && (
            <p className="error-text">{errors.nationality}</p>
          )}
        </div>
      </div>

      {/* ຊົນເຜົ່າ / ສາດສະໜາ / ເບີໂທ */}
      <div className="grid-container" style={{ marginTop: "1.3rem" }}>
        <div>
          <label style={labelStyle}>
            ຊົນເຜົ່າ
            {!values.tribe && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="tribe"
            value={values.tribe}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນຊົນເຜົ່າ"
          />
          {errors.tribe && <p className="error-text">{errors.tribe}</p>}
        </div>
        <div>
          <label style={labelStyle}>
            ສາດສະໜາ
            {!values.religion && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="religion"
            value={values.religion}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນສາດສະໜາ"
          />
          {errors.religion && (
            <p className="error-text">{errors.religion}</p>
          )}
        </div>
        <div>
          <label style={labelStyle}>
            ເບີໂທ ຫຼື WHATAPP
            {!values.phoneNumber && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="tel"
            name="phoneNumber"
            inputMode="numeric"
            value={values.phoneNumber}
            onChange={handleChange}
            style={inputStyle}
            placeholder="85620XXXXXXXX"
          />
          {errors.phoneNumber && (
            <p className="error-text">{errors.phoneNumber}</p>
          )}
        </div>
      </div>

      <div className="grid-section" style={{ marginTop: "1.3rem" }}>
        {/* ພ້ອມເລີ່ມວຽກ */}
        <div>
          <label style={labelStyle}>
            ທ່ານພ້ອມຈະເລີ່ມວຽກມື້ໃດ
            {!values.ready && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="ready"
            value={values.ready}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນມື້ເລີ່ມວຽກ"
          />
          {errors.ready && <p className="error-text">{errors.ready}</p>}
        </div>

        {/* ແຫຼ່ງຂ່າວ */}
        <div>
          <label style={labelStyle}>
            ທ່ານຮູ້ຂ່າວການປະກາດຮັບສະໝັກຕຳແໜ່ງຈາກໃສ
            {!values.recruitmentNew && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <select
            name="recruitmentNew"
            value={values.recruitmentNew}
            onChange={handleChange}
            style={{ ...inputStyle, cursor: "pointer" }}
          >
            <option value="">-- ເລືອກແຫຼ່ງຂ່າວ --</option>
            <option value="Facebook">Facebook</option>
            <option value="TikTok">TikTok</option>
            <option value="Social Media ອື່ນໆ">Social Media ອື່ນໆ</option>
            <option value="ເວັບໄຊບໍລິສັດ ອານຸສິດ">ເວັບໄຊບໍລິສັດ ອານຸສິດ</option>
            <option value="ເວັບຝາກວຽກ">ເວັບຝາກວຽກ</option>
            <option value="ຮູ້ຈາກໝູ່/ຄົນຮູ້ຈັກ">ຮູ້ຈາກໝູ່/ຄົນຮູ້ຈັກ</option>
            <option value="ໂປສເຕີ/ປ້າຍປະກາດ">ໂປສເຕີ/ປ້າຍປະກາດ</option>
            <option value="ອື່ນໆ">ອື່ນໆ</option>
          </select>
          {values.recruitmentNew === "OTHER" && (
            <input
              type="text"
              name="recruitmentNewOther"
              value={values.recruitmentNewOther || ""}
              onChange={handleChange}
              style={{ ...inputStyle, marginTop: "0.75rem" }}
              placeholder="ກະລຸນາລະບຸແຫຼ່ງອື່ນໆ..."
            />
          )}

          {errors.recruitmentNew && (
            <p className="error-text">{errors.recruitmentNew}</p>
          )}
        </div>

        {/* เงินเดือน */}
        <div>
          <label style={labelStyle}>ເງິນເດືອນທີ່ຜ່ານມາ</label>
          <input
            type="text"
            inputMode="numeric"
            name="previousSalary"
            value={salaryPrevDisplay}
            onChange={handlePrevSalaryChange}
            style={inputStyle}
            placeholder="ປ້ອນເງີນເດືອນທີ່ຜ່ານມາ"
          />
          {errors.previousSalary && (
            <p className="error-text">{errors.previousSalary}</p>
          )}
        </div>
        <div>
          <label style={labelStyle}>
            ເງິນເດືອນທີ່ຕ້ອງການ
            {!values.requiredSalary && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            inputMode="numeric"
            name="requiredSalary"
            value={salaryReqDisplay}
            onChange={handleReqSalaryChange}
            style={inputStyle}
            placeholder="ປ້ອນເງິນເດືອນທີ່ຕ້ອງການ"
          />
          {errors.requiredSalary && (
            <p className="error-text">{errors.requiredSalary}</p>
          )}
        </div>
      </div>

      {/* Address blocks */}
      <div className="grid-container">
        <div>
          <label style={labelStyle}>
            ບ້ານເກີດ
            {!values.village && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="village"
            value={values.village}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນບ້ານເກີດ"
          />
          {errors.village && <p className="error-text">{errors.village}</p>}
        </div>
        <div>
          <label style={labelStyle}>
            ເມືອງ
            {!values.district && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="district"
            value={values.district}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນເມືອງ"
          />
          {errors.district && <p className="error-text">{errors.district}</p>}
        </div>
        <div>
          <label style={labelStyle}>
            ແຂວງ
            {!values.province && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="province"
            value={values.province}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນແຂວງ"
          />
          {errors.province && (
            <p className="error-text">{errors.province}</p>
          )}
        </div>

        <div>
          <label style={labelStyle}>
            ທີ່ຢູ່ປັດຈຸບັນ
            {!values.villageNew && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="villageNew"
            value={values.villageNew}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນທີ່ຢູ່ປັດຈຸບັນ"
          />
          {errors.villageNew && (
            <p className="error-text">{errors.villageNew}</p>
          )}
        </div>
        <div>
          <label style={labelStyle}>
            ເມືອງ{" "}
            {!values.districtNew && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="districtNew"
            value={values.districtNew}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນເມືອງປັດຈຸບັນ"
          />
          {errors.districtNew && (
            <p className="error-text">{errors.districtNew}</p>
          )}
        </div>
        <div>
          <label style={labelStyle}>
            ແຂວງ
            {!values.provinceNew && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="provinceNew"
            value={values.provinceNew}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນແຂວງປັດຈຸບັນ"
          />
          {errors.provinceNew && (
            <p className="error-text">{errors.provinceNew}</p>
          )}
        </div>
      </div>

      {/* ສະຖານະ */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
          marginTop: "2.5rem",
        }}
      >
        <span style={{ minWidth: 72, color: "#111827" }}>
          {!values.statusPerson && (
            <span style={{ color: "red", marginLeft: 4 }}>*</span>
          )}
          ສະຖານະ:
        </span>

        {/* SINGLES */}
        <input
          type="radio"
          id="statusPerson-SINGLES"
          name="statusPerson"
          value="SINGLES"
          checked={values.statusPerson === "SINGLES"}
          onChange={handleStatusChange}
          style={{ display: "none" }}
        />
        <label
          htmlFor="statusPerson-SINGLES"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
        >
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "999px",
              border: "2px solid #475569",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {values.statusPerson === "SINGLES" && (
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#334155",
                }}
              />
            )}
          </span>
          <span>ໂສດ</span>
        </label>

        {/* MARRIED */}
        <input
          type="radio"
          id="statusPerson-MARRIED"
          name="statusPerson"
          value="MARRIED"
          checked={values.statusPerson === "MARRIED"}
          onChange={handleStatusChange}
          style={{ display: "none" }}
        />
        <label
          htmlFor="statusPerson-MARRIED"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
        >
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "999px",
              border: "2px solid #475569",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {values.statusPerson === "MARRIED" && (
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#334155",
                }}
              />
            )}
          </span>
          <span>ແຕ່ງງານ</span>
        </label>

        {/* OTHER */}
        <input
          type="radio"
          id="statusPerson-OTHER"
          name="statusPerson"
          value="OTHER"
          checked={values.statusPerson === "OTHER"}
          onChange={handleStatusChange}
          style={{ display: "none" }}
        />
        <label
          htmlFor="statusPerson-OTHER"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
        >
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "999px",
              border: "2px solid #475569",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {values.statusPerson === "OTHER" && (
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#334155",
                }}
              />
            )}
          </span>
          <span>ອື່ນໆ</span>
        </label>

        {/* detailStatusOther */}
        {values.statusPerson === "OTHER" && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "4px",
            }}
          >
            <input
              type="text"
              name="detailStatusOther"
              placeholder="ລະບຸສະຖານະອື່ນໆ..."
              value={values.detailStatusOther}
              onChange={handleChange}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #cbd5e1",
                width: "240px",
              }}
            />

            {errors.detailStatusOther && (
              <p
                className="error-text"
                style={{
                  color: "#dc2626",
                  fontSize: "0.8rem",
                  margin: 0,
                }}
              >
                {errors.detailStatusOther}
              </p>
            )}
          </div>
        )}
      </div>

      {values.statusPerson &&
      ["MARRIED", "SINGLES", "OTHER"].includes(values.statusPerson)
        ? null
        : errors.statusPerson && (
            <p className="error-text">{errors.statusPerson}</p>
          )}
    </>
  );
}